module.exports = __webpack_public_path__ + "static/media/lang_course_main.cc296bbd.png";